import React from "react";
import { productBrief } from "../data/productBrief";
export function PrepBanner() {
  return <div className="prep-banner" role="note" data-id="element-105" data-mp="1ktqwf9vc7uno">
      {productBrief.status}
    </div>;
}